import type { DirectiveBinding } from 'vue'
import DOMPurify from 'dompurify'

// 自定义 DOMPurify 配置
function getDOMPurifyConfig() {
  return {
    ALLOW_DATA_ATTR: true, // 允许 data-* 属性
    ALLOW_UNKNOWN_PROTOCOLS: true, // 允许未知协议（如 tel:、mailto:）
    FORBID_TAGS: ['script'], // 禁止 script 标签
    FORBID_ATTR: ['onclick', 'onerror', 'onload'], // 禁止危险的事件属性
  }
}

// 清理 HTML 内容的函数
function sanitizeHTML(dirtyHtml: string): string {
  try {
    return DOMPurify.sanitize(dirtyHtml, getDOMPurifyConfig())
  }
  catch (error) {
    console.error('Error sanitizing HTML:', error)
    return ''
  }
}

// 自定义指令（简写形式）
export function vSafeHtml(el: HTMLElement, binding: DirectiveBinding<string | null | undefined>) {
  const value = binding.value
  if (value === undefined || value === null) {
    el.innerHTML = ''
  }
  else {
    el.innerHTML = sanitizeHTML(value)
  }
}
